module.exports = __webpack_public_path__ + "img/teams.79d91c28.png";